// 261010 UI-errbox — MỘT dòng tóm tắt lỗi của bước (thay hộp đỏ liệt kê). Chi tiết từng video gấp sau «Chi tiết»; chữ thô của máy chủ chỉ ở Tooltip.
// Giữ id/testid `wf-step-flags` ở WorkflowAssetFlags (nút «Xử lý N lỗi» cuộn tới).
import React, { useState } from 'react';
import { Tooltip } from 'antd';
import type { PrimaryCall } from './workflowPrimaryPolicy';
import type { StepFailSummary } from './stepFailSummary';
import WfIcon from './WfIcon';

interface Props {
  summary: StepFailSummary;
  sending: boolean;
  onRun: (call: PrimaryCall | null) => void;
}

const WorkflowStepFailSummary: React.FC<Props> = ({ summary, sending, onRun }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`wf-failline wf-failsum${summary.bad ? '' : ' warn'}`} role="status" data-testid="wf-failsum">
      <div className="wf-failsum-l">
        {summary.groups.map((g) => (
          <span key={g.key} className="wf-failsum-g" data-testid={`wf-failsum-${g.key}`}>
            <span className={`wf-si ${g.tone}`}><WfIcon name={g.icon} /></span>
            <span className="t">{g.text}</span>
            {g.action ? (
              <Tooltip title={g.action.hint}>
                <button type="button" className="wf-btn" disabled={sending} onClick={() => onRun(g.action!.call)} data-testid={`wf-failsum-act-${g.key}`}>{g.action.label}</button>
              </Tooltip>
            ) : null}
          </span>
        ))}
        <button type="button" className="wf-plink" aria-expanded={open} onClick={() => setOpen((v) => !v)} data-testid="wf-failsum-toggle">{open ? 'Thu gọn' : 'Chi tiết'}</button>
      </div>
      {open ? (
        <ul className="wf-failsum-d" data-testid="wf-failsum-details">
          {summary.groups.flatMap((g) => g.entries.map((e, i) => (
            <li key={`${g.key}-${i}`}>
              <span className={`wf-si ${g.tone}`}><WfIcon name={g.icon} /></span>
              <b>{e.label}</b>
              {e.raw ? <Tooltip title={e.raw}><span className="msg">{e.reason}</span></Tooltip> : <span className="msg">{e.reason}</span>}
            </li>
          )))}
        </ul>
      ) : null}
    </div>
  );
};

export default WorkflowStepFailSummary;
